import React from 'react';
import MassEditModal from '../mass-edit-modal';
import { Form } from 'react-bootstrap';
import { useEditor } from '../mass-edit-modals';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates'
import Toggle from 'react-toggle'

export default () => {
    const editor = useEditor({
        getInitialValue: (e) => ({ rollOutDate: e.rollOutDate, ['private']: e['private']})
    })
    const [pickerVisible, setVisible] = React.useState(false)

    const onPrivateChange = React.useCallback((checked) => {
        if (!checked) {
            editor.setValue(({ ['private']: false }))
        } else {
            editor.setValue(({ ['private']: true }))
        }
    }, [editor.value])

    const onDateChange = (value) => {
        console.log({value})
        editor.setValue((e) => ({
            ...e,
            rollOutDate: value ? value.toDate() : undefined
        }));
    }

    const renderDate = () => !editor.value['private'] ? null : (
        <Form.Group>
            <Form.Label>Rollout Date</Form.Label>
            <SingleDatePicker
                placeholder='Optional'
                date={editor.value.rollOutDate? moment(editor.value.rollOutDate) : undefined}
                onDateChange={onDateChange}
                focused={pickerVisible}
                onFocusChange={({ focused }) => setVisible(focused)}
                numberOfMonths={1}
                hideKeyboardShortcutsPanel
                showClearDate
                regular
            />
        </Form.Group>
    )

    return (
        <MassEditModal
            title={`Edit ${editor.experiences.length} Rollout Dates`}
            onCancel={editor.onClose}
            onSave={editor.save}
            busy={editor.isBusy}
        >
            <Form.Group>
                <Form.Label>Private List Visiblity</Form.Label>
                <div>
                    <Toggle
                        checked={Boolean(editor.value['private'])}
                        onChange={e => onPrivateChange(e.target.checked)}
                        icons={false}
                    />
                </div>
            </Form.Group>
            {renderDate()}
        </MassEditModal>
    );
};
